import React from "react";
import teampicture from "../Team/images/teampicture.jpeg";
import "./Team.css";

export default function Team() {
    return (
        <>
            <div className="team" id="Team">
                <div className="team-container-picture">
                    <h2 className="team-title">Η ομάδα<span>.</span></h2>
                    <img src={teampicture} className="team-picture"  alt=""/>
                </div>
                <div className="team-container-details">
                    <div className="team-details-text">Η πρωτοβουλία για την ίδρυση του φοροτεχνικού - λογιστικού γραφείου
                    ήταν αποτέλεσμα μιας πολύχρονης εργασιακής και εκπαιδευτικής πορείας που είχα σε
                    όλο το φάσμα της λογιστικής - φοροτεχνικής - ελεγκτικής - διοικητικής εμπειρίας μου ,
                        σε μικρές και μεγάλες εταιρείες.<br /><br />
                        Μέσα από την εμπειρία μου σε πολύπλοκους επιχειρηματικούς τομείς είναι γεγονός ότι για τη σωστή
                        οργάνωση ενός λογιστηρίου,
                        η παροχή επιχειρηματικής πληροφόρησης και η σωστή συμβουλευτική μπορούν να βοηθήσουν
                        ουσιαστικά τους επιχειρηματίες αλλά και τους ιδιώτες να αναπτυχθούν υγειώς σε
                        ένα ασταθές και συνεχές μεταβαλλόμενο οικονομικό περιβάλλον. <br /><br />
                        Το όραμα μου ήταν να δώσω λύση στα προβλήματα που όλοι φορολογούμενοι αντιμετωπίζουν όταν
                        βρίσκονται αντιμέτωποι με ένα φορολογικό και νομικό πλαίσιο .
                        Πρωταρχική μέριμνα του γραφείου είναι η επίλυση των προβλημάτων των φορολογούμενων
                        τόσο των φυσικών όσο και των νομικών προσώπων.
                        Σημαντικό ρόλο για την επίτευξη των στόχων αυτών έχει παίξει τόσο η αυξημένη εμπειρία
                        μου όσο και οι σπουδές μου στο Οικονομικό Πανεπιστήμιο της Θεσσαλονίκης.
                        <br /><br />
                        Με εκτίμηση
                        <br /><br />
                        Aδαμάντιος Βασιλόπουλος
                        <h3>CEO <br /></h3>
                    </div>
                </div>
            </div>
        </>
    );
}